/**
 * PopoverContext
 */
import * as React from "react"

type ContextProps = {
  stack: React.MutableRefObject<HTMLElement[]>
}

const initialContext: ContextProps = {
  stack: { current: [] }
}
const PopoverContext: React.Context<ContextProps> = React.createContext(
  initialContext
)

export default PopoverContext
